// work_item deep-link URL 參數的唯一真相來源。
//
// 讀寫 URL 上的工作項目參數一律走這裡,不要在元件裡自己 sp.set('wi', ...) /
// sp.get('wi')。歷史上就是因為各處自己組參數,漏清一個殘留的 cid 就會解到別張項目。
//
// 參數語義(一個參數一個意思,不靠其他參數的有無來推斷型別):
//   wino  = 公司內顯示編號 work_item_no(畫面上的 #號),必須搭配 cid 界定公司
//   wi    = 資料庫主鍵 id,全域唯一,不需要 cid
//   wisub = 子項 id(子項沒有 work_item_no,只能用 id)
//   cid   = 公司 slug。它只是「編號」的公司 scope,絕不再兼任型別判斷依據。
//
// LEGACY:2026-08-19(commit 21f158b)到 2026-09-03 之間產出的連結格式是
// ?cid=<slug>&wi=<work_item_no>,亦即「有 cid 時 wi 是編號」。那段期間分享出去
// 的連結、通知、書籤仍需可用,故讀取端保留相容分支;寫入端一律不再產生該格式。

/** 讀出 URL 指向哪一個工作項目。回傳 null = URL 沒有指任何項目。 */
export const parseWorkItemRef = (search) => {
  const sp = search instanceof URLSearchParams ? search : new URLSearchParams(search || '');
  const cid = sp.get('cid');
  const subRaw = sp.get('wisub');
  const subId = subRaw && Number.isFinite(Number(subRaw)) ? Number(subRaw) : null;

  const wino = sp.get('wino');
  if (wino && Number.isFinite(Number(wino))) {
    return { by: 'no', no: Number(wino), cid, subId, legacy: false };
  }

  const wi = sp.get('wi');
  if (!wi || !Number.isFinite(Number(wi))) return null;

  // LEGACY:cid + wi。排除 cid + ticket(那是 Ticket deep-link 的 cid,跟工作項目無關)。
  if (cid && !sp.get('ticket')) {
    return { by: 'no', no: Number(wi), cid, subId, legacy: true };
  }
  return { by: 'id', id: Number(wi), subId, legacy: false };
};

/** 寫入:用資料庫 id 指向項目(子項、拿不到公司 slug、或編號還沒解出來時)。 */
export const setWorkItemRefById = (sp, id, { subId = null } = {}) => {
  sp.delete('wino');
  sp.delete('cid');    // cid 只服務「編號」語義,用 id 時必須清掉,否則會被當成編號解析
  sp.delete('ticket'); // ticket 與 cid 成對,cid 清掉就不能留 ticket
  sp.set('wi', String(id));
  if (subId != null) sp.set('wisub', String(subId)); else sp.delete('wisub');
  return sp;
};

/** 寫入:用 (公司 slug, 顯示編號) 指向項目 — 正規形式,網址編號與畫面 #號一致。 */
export const setWorkItemRefByNo = (sp, no, cid, { subId = null } = {}) => {
  sp.delete('wi');
  sp.delete('ticket');
  sp.set('cid', cid);
  sp.set('wino', String(no));
  if (subId != null) sp.set('wisub', String(subId)); else sp.delete('wisub');
  return sp;
};

/** 清除:關 drawer / 離開項目。cid 若還被 Ticket deep-link 用著就留下。 */
export const clearWorkItemRef = (sp) => {
  sp.delete('wi');
  sp.delete('wino');
  sp.delete('wisub');
  if (!sp.get('ticket')) sp.delete('cid');
  return sp;
};

/** URL 上是否指著某個工作項目(給清除前的判斷用)。 */
export const hasWorkItemRef = (search) => parseWorkItemRef(search) !== null;
